import CabeceraPagina from './CabeceraPagina.jsx';
import limpiarHtml from './limpiarHtml.js';

// Pàgina de text llarg de l'admin (Clientes, Legal, Cookies...): hero + lectura.
// "logo" és la capa de sota del hero (veure CabeceraPagina).
const PaginaTexto = ({ titulo, eyebrow, imagen, logo, html }) => (
    <>
        <CabeceraPagina titulo={titulo} eyebrow={eyebrow} imagen={imagen} logo={logo} />
        <section className="bhe-prose" dangerouslySetInnerHTML={{ __html: limpiarHtml(html) }}></section>
    </>
);

export default PaginaTexto;
